/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function TariffOfFeesInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Tariff of Fees and Expenses for Nova Scotia Elections"
              description={
                <>
                  {/* <h4>Please note, the Tariff of Fees and Expenses has been updated to reflect a CPI increase of 3.6% for 2023. The increases are effective for expenses incurred on or after April 1, 2024.</h4> */}
                  <br />
                  <p>The <a href="/files/TariffOfFees/EL-Election Tariff of Fees and Expenses-CPI Update April 1, 2026.pdf"> <em>Tariff of Fees and Expenses</em></a> is made under the <a href="https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf"><em>Elections Act</em></a> and sets out what people are to be paid for working in the administration of an election, usually during an election.</p>
                  <br />
                  <p>As per subsection 18(2) of the Act, the adjusted tariff to reflect CPI is required to posted annually on or before April 1st. </p>
                  <br />
                  {/* <p>The<a href="/files/TariffOfFees/EL-Election%20Tariff%20of%20Fees%20and%20Expenses-CPI%20Update%20June%206%2C%202024.pdf"> Tariff of Fees and Expenses</a> has been updated to reflect a CPI increase of 3.6% for 2023. The increases are effective for expenses incurred on or after April 1, 2024.</p>
                  <br /> */}
                  <p>Many of the fees set out in the tariff are based on the minimum wage in Nova Scotia. The minimum wage in Nova Scotia will adjust as follows:<br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>October 1, 2025 - $16.50</li>
                    <li>April 1, 2026 - $16.75</li>
                    <li>October 1, 2026 - $17.00</li>
                  </ul></p>
            </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default TariffOfFeesInformation;
